import CssBaseline from '@mui/material/CssBaseline';
import { StyledEngineProvider } from '@mui/material/styles';
import { JsonAPIDocument } from 'json-api-hooks';
import React, { FC, ReactNode } from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter } from 'react-router-dom';

import HeadingContext from '../Heading/HeadingContext';
import ModalContextProvider from '../Modal/ModalContextProvider';
import ModalWrapper from '../Modal/ModalWrapper';
import SnackbarManager from '../Snackbar/SnackbarManager';

import ApiProvider from './ApiProvider';
import ContentFrame from './ContentFrame';
import ErrorBoundary from './ErrorBoundary';
import ThemeProvider from './ThemeProvider';

export interface RouterProps {
  children?: ReactNode;
}

export interface AppProps {
  children: ReactNode;
  header: FC;
  location?: string;
  seed: JsonAPIDocument[];
  snackbar?: string;
  badge?: string;
}

const App = ({ badge, children, header, seed, snackbar }: AppProps): JSX.Element | null => {
  return (
    <HelmetProvider>
      <SnackbarManager initialMessage={snackbar}>
        <BrowserRouter>
          <ModalContextProvider badge={badge}>
            <ApiProvider seed={seed}>
              <StyledEngineProvider injectFirst>
                <ThemeProvider>
                  <CssBaseline />
                  <HeadingContext>
                    <ContentFrame header={header}>
                      <ErrorBoundary>{children}</ErrorBoundary>
                    </ContentFrame>
                    <ModalWrapper />
                  </HeadingContext>
                </ThemeProvider>
              </StyledEngineProvider>
            </ApiProvider>
          </ModalContextProvider>
        </BrowserRouter>
      </SnackbarManager>
    </HelmetProvider>
  );
};

export default App;
